module.exports = __webpack_public_path__ + "static/media/tire-repair.f23474f9.svg";